export default __webpack_public_path__ + "static/media/notif.c426d7cd.ogg";